import React, { useState } from 'react';
import SearchItemWrapper from './Search.styles';
import Input from '@iso/ui/Antd/Input/Input';
import SearchIcon from '@iso/assets/images/search-icon.svg';
import { useIntl } from 'react-intl';

const Search = ({ onChange }) => {
  const intl = useIntl();
  return (
    <SearchItemWrapper>
      <Input
        type="text"
        placeholder={intl.formatMessage({
          id: 'search.label',
        })}
        onChange={onChange}
      />
      <img src={SearchIcon} alt="Search-icon" />
    </SearchItemWrapper>
  );
};

export default Search;
